import script from "./AIServicesConfiguration.vue?vue&type=script&setup=true&lang=js"
export * from "./AIServicesConfiguration.vue?vue&type=script&setup=true&lang=js"

import "./AIServicesConfiguration.vue?vue&type=style&index=0&id=2b5c2b30&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b5c2b30"]])

export default __exports__